var _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBeneficiary({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 1.71429C0 0.767512 0.767512 0 1.71429 0H28.2857C29.2325 0 30 0.767512 30 1.71429V28.2857C30 29.2325 29.2325 30 28.2857 30H1.71429C0.767512 30 0 29.2325 0 28.2857V1.71429Z",
    fill: "#292828"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0535 17.9464C12.8672 17.9464 13.5268 17.2868 13.5268 16.4732C13.5268 15.6596 12.8672 15 12.0535 15C11.2399 15 10.5803 15.6596 10.5803 16.4732C10.5803 17.2868 11.2399 17.9464 12.0535 17.9464Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9464 17.9464C18.76 17.9464 19.4196 17.2868 19.4196 16.4732C19.4196 15.6596 18.76 15 17.9464 15C17.1327 15 16.4731 15.6596 16.4731 16.4732C16.4731 17.2868 17.1327 17.9464 17.9464 17.9464Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 12.0536C15.8135 12.0536 16.473 11.394 16.473 10.5804C16.473 9.76676 15.8135 9.10718 14.9998 9.10718C14.1862 9.10718 13.5266 9.76676 13.5266 10.5804C13.5266 11.394 14.1862 12.0536 14.9998 12.0536Z",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M14.9998 20.8928C14.9998 19.2656 13.6806 17.9464 12.0534 17.9464C10.4261 17.9464 9.10693 19.2656 9.10693 20.8928",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M20.8929 20.8928C20.8929 19.2656 19.5737 17.9464 17.9464 17.9464C16.3192 17.9464 15 19.2656 15 20.8928",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M17.9463 15C17.9463 13.3728 16.6271 12.0536 14.9999 12.0536C13.3726 12.0536 12.0535 13.3728 12.0535 15",
    stroke: "#FF8F01",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBeneficiary);
export default __webpack_public_path__ + "static/media/beneficiary.d81eebdedb90df384373b821867d7955.svg";
export { ForwardRef as ReactComponent };